import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=1573ae86&scoped=true&"
import script from "./ImageUploader.vue?vue&type=script&lang=ts&"
export * from "./ImageUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=1573ae86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573ae86",
  null
  
)

export default component.exports